import React from 'react'

import {
  ConfirmationSection,
  ConfirmationCard,
  ConfirmHighlight,
} from './BookingsPortalPage.styled'

import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'

type ConfirmationViewProps = {
  title: string
  partnerServiceName?: string
  nameLine: string
  dateTimeLine: string
  email: string
  phone?: string
  paragraphs: string[]
}

export const ConfirmationView: React.FC<ConfirmationViewProps> = ({
  title,
  partnerServiceName,
  nameLine,
  dateTimeLine,
  email,
  phone,
  paragraphs,
}) => (
  <ConfirmationSection>
    <ConfirmationCard>
      <Container direction="column" spacing={2} align="center">
        <Typography size="xl" weight="bold" textAlign="center">
          {title}
        </Typography>
        <ConfirmHighlight>
          <Typography weight="bold">{partnerServiceName || '—'}</Typography>
          <Typography weight="bold">{nameLine}</Typography>
          <Typography weight="bold">{dateTimeLine}</Typography>
          <Typography weight="bold">{email || '—'}</Typography>
          {phone ? <Typography weight="bold">{phone}</Typography> : null}
        </ConfirmHighlight>
        <Container direction="column" spacing={1}>
          {paragraphs.map((p, idx) => (
            <Typography key={`p-${idx}`} textAlign="center">
              {p}
            </Typography>
          ))}
        </Container>
      </Container>
    </ConfirmationCard>
  </ConfirmationSection>
)
